module.exports = __webpack_public_path__ + "static/media/browse-electric-card.5e070216.png";